import React, { useEffect, useRef, useState } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import {
  Button,
  FieldTextInput,
  Form,
  IconClose,
  ImageFromFile,
  OutsideClickHandler,
  ReactHlsPlayer,
  ResponsiveImage,
} from '../../../../components';
import css from './EditCommentModal.module.css';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import EmojiPicker from 'emoji-picker-react';
import VideoUploadModal from '../CreatePostForm/VideoUploadModal';
import ImageUploadModal from '../CreatePostForm/ImageUploadModal';
import GifUploadModal from '../CreatePostForm/GifUploadModal';
import FileUploadModal from '../CreatePostForm/FileUploadModal';

import { RichUtils } from 'draft-js';
import CircleBlockEditor from '../../../../components/CircleBlockEditor/CircleBlockEditor';
import EditorOptionDropdown from '../CreatePostForm/EditorOptionDropdown';

const EditCommentForm = props => {
  const playerRef = useRef(null);

  useEffect(() => {
    if (playerRef.current) {
      const video = playerRef.current.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', 'true');
        video.setAttribute('muted', 'true'); // Mute for Safari autoplay policies
      }
    }
  }, [playerRef]);

  return (
    <FinalForm
      {...props}
      render={fieldRenderProps => {
        const {
          form,
          handleSubmit,
          inProgress,
          invalid,
          pristine,
          submitting,
          requestCreateComment,
          onEmojiClick,
          isEmojiOpen,
          values,
          requestDirectUpload = false,
          onGiphyChange,
          onDocumentClick,
          onImageClick,
          onVideoClick,
          isGiphyOpen,
          isDocumentModal,
          isImageModal,
          isVideoUpload,
          formOldValues,
          setFormOldValues,
          editorState,
          setEditorState,
          insertEmoji,
          advancedSearchData,
          onAdvancedSearch,
          currentUser
        } = fieldRenderProps;

        const [isEditorOptionOpen, setIsEditorOptionOpen] = useState(false);
        const [limitExceed, setLimitExceed] = useState(false);

        const handleEmoji = emoji => {
          insertEmoji(emoji.emoji)
        };

        const handleCommentBody = e => {
          setFormOldValues({
            ...formOldValues,
            commentBody: e.target.value,
          });
        };

        const handleRemoveItem = (item, type, fileType) => {
          if (item?.signed_id) {
            console.log('item', item, type);
            setFormOldValues(prevState => {
              const updatedValues = {
                ...prevState,
                [type]: prevState[type]?.filter(value => value.signed_id !== item.signed_id),
                [fileType]: prevState[fileType]?.filter(value => value !== item),
              };

              return updatedValues;
            });
          }
          setFormOldValues(prevState => {
            const updatedValues = {
              ...prevState,
              [type]: prevState[type].filter(value => value !== item),
            };

            return updatedValues;
          });
        };

        const toggleDropdown = () => {
          setIsEditorOptionOpen(prev => !prev);
        };

        const toggleBlockType = blockType => {
          setEditorState(RichUtils.toggleBlockType(editorState, blockType));
        };

        const toggleInlineStyle = inlineStyle => {
          // Simply toggle the inline style at the current cursor position
          // This will apply to future typed text without selecting existing text
          setEditorState(RichUtils.toggleInlineStyle(editorState, inlineStyle));
        };

        const getCurrentBlockType = () => {
          const selection = editorState.getSelection();
          const content = editorState.getCurrentContent();
          const block = content.getBlockForKey(selection.getStartKey());
          return block.getType();
        };

        const getCurrentInlineStyle = () => {
          return editorState.getCurrentInlineStyle();
        };

        const currentBlockType = getCurrentBlockType();
        const currentInlineStyle = getCurrentInlineStyle();

        return (
          <Form
            onSubmit={values => {
              handleSubmit(values), form.reset();
            }}
          >
            <div className={css.simpleCommentContainer}>
              <div className={css.inputText}>
                <div className={css.inputEditor}>
                  <CircleBlockEditor
                    editorState={editorState}
                    setEditorState={setEditorState}
                    advancedSearchData={advancedSearchData}
                    onAdvancedSearch={onAdvancedSearch}
                    currentBlockType={currentBlockType}
                    setLimitExceed={setLimitExceed}
                    currentUser={currentUser}
                  />
                </div>
                <br/>
                {limitExceed ? <span className={css.errorText}><FormattedMessage id="CreatePost.errorText" /></span> : null}
                {/* <FieldTextInput
                  className={css.inputBox}
                  id={'commentBody'}
                  name={'commentBody'}
                  type="text"
                  placeholder="What are your thoughts?"
                  onChange={handleCommentBody}
                /> */}
                <div className={css.inlineAttachments}>



                  {/* render items from edit comment section */}
                  {Array.isArray(values?.image)
                    ?
                    <div className={css.imageuploadedWrapper}>
                      {values?.image.map(file => {
                        if (file?.image_variants?.thumbnail) {
                          return (
                            <div>
                              <div onClick={() => handleRemoveItem(file, 'image', '')} className={css.closeIcon}><IconClose /></div>
                              <ResponsiveImage imagewithURL={file?.image_variants?.thumbnail} />
                            </div>
                          );
                        }
                      })}
                    </div>
                    : null}

                  {Array.isArray(values?.gifs) && values?.gifs.length > 0
                    ?
                    <div>
                      {values?.gifs.map(file => {
                        if (file?.video_variants?.hls)
                          return (
                            <div>
                              <div onClick={() => handleRemoveItem(file, 'gifs', '')} className={css.closeIcon}><IconClose /></div>
                              <ReactHlsPlayer
                                src={file?.video_variants?.hls}
                                autoPlay={true}
                                controls={true}
                                width="100%"
                                height="auto"
                                playsInline
                                playerRef={playerRef}
                                // onEnded={handleVideoEnd}
                                poster={file?.image_variants?.thumbnail}
                              />
                            </div>
                          );
                      })}
                    </div>
                    : null}
                  {Array.isArray(values?.video) && values?.video.length > 0
                    ?
                    <div>
                      {values?.video.map(file => {
                        if (file?.video_variants?.hls)
                          console.log('file', file);
                        return (
                          <div className={css.videoContainer}>
                            <div onClick={() => handleRemoveItem(file, 'video', '')} className={css.closeIcon}><IconClose /></div>
                            <ReactHlsPlayer
                              src={file?.video_variants?.hls}
                              autoPlay={true}
                              controls={true}
                              width="100%"
                              height="auto"
                              // onEnded={handleVideoEnd}
                              poster={file?.image_variants?.thumbnail}
                            />
                            <div className={css.videoDuration}>{file?.filename}</div>
                          </div>
                        );
                      })}
                    </div>
                    : null}
                  {Array.isArray(values?.document) && values?.document.length > 0
                    ?
                    <div className={css.fileUplaodedWrapper}>
                      {values?.document.map(file => {
                        return (
                          <div>
                            <div onClick={() => handleRemoveItem(file, 'document', '')} className={css.closeIcon}><IconClose /></div>
                            <div className={css.fileUploaded} key={file}>
                              {file.filename}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    : null}

                  {/* render images */}
                  {Array.isArray(values?.imagefiles) && values?.imagefiles.length > 0
                    ?
                    <div className={css.imageuploadedWrapper}>
                      {values?.imagefiles.map(file => {
                        return (
                          <div >
                            <div onClick={() => handleRemoveItem(file, 'image', 'imagefiles')} className={css.closeIcon}>
                              <IconClose />
                            </div>
                            <ImageFromFile
                              id={file.file.name}
                              className={''}
                              file={file.file}
                              aspectWidth={1}
                              aspectHeight={1}
                            />
                          </div>
                        );
                      })}
                    </div>
                    : null}
                  {/* render gifs */}
                  {Array.isArray(values?.giffiles) && values?.giffiles.length > 0
                    ?
                    <div className={css.gifUploadWrapper}>
                      {values?.giffiles.map(file => {
                        return (
                          <div>
                            <div onClick={() => handleRemoveItem(file, 'gifs', 'giffiles')} className={css.closeIcon}><IconClose /></div>
                            <img src={file.file} />
                          </div>
                        );
                      })}
                    </div>
                    : null}

                  {/* render videos */}
                  {Array.isArray(values?.videofiles) && values?.videofiles.length > 0
                    ?
                    <div className={css.videoWrapper}>
                      {values?.videofiles.map(file => {
                        return (
                          <div>
                            <div onClick={() => handleRemoveItem(file, 'video', 'videofiles')} className={css.closeIcon}>
                              <IconClose />
                            </div>
                            <video src={file.file} loop autoPlay muted />
                          </div>
                        );
                      })}
                    </div>
                    : null}
                </div>

                <div className={css.row}>
                  <div className={css.bottomFunctionMenu}>
                    <div className={css.leftIconSection}>

                      <div className={css.documentUpload}>
                        {/* //isEditorOptionOpen, setIsEditorOptionOpen */}
                        <OutsideClickHandler onOutsideClick={() => isEditorOptionOpen && setIsEditorOptionOpen(false)}>
                          <label className={css.uplaodIcon} onClick={toggleDropdown}>
                            <ProfileIconCard type="add_file" />
                          </label>
                          <div className={css.editDropdown}>
                            {isEditorOptionOpen ? (
                              <EditorOptionDropdown
                                toggleDropdown={toggleDropdown}
                                toggleBlockType={toggleBlockType}
                                toggleInlineStyle={toggleInlineStyle}
                                currentBlockType={currentBlockType}
                                currentInlineStyle={currentInlineStyle}
                              />
                            ) : null}
                          </div>
                        </OutsideClickHandler>
                      </div>

                      <div className={css.inputField}>
                        <label className={css.uplaodIcon} onClick={onDocumentClick}>
                          <ProfileIconCard type="document_uplaod" />
                        </label>
                        {isDocumentModal ? (
                          <FileUploadModal
                            isDocumentModal={isDocumentModal}
                            onDocumentClick={onDocumentClick}
                            form={form}
                            values={values}
                            requestDirectUpload={requestDirectUpload}
                            formOldValues={formOldValues}
                            setFormOldValues={setFormOldValues}
                          />
                        ) : null}
                      </div>

                      <div className={css.gifSection}>
                        <div className={css.uplaodIcon} onClick={onGiphyChange}>
                          <ProfileIconCard type="gif" />
                        </div>

                        {isGiphyOpen ? (
                          <GifUploadModal
                            isGiphyOpen={isGiphyOpen}
                            onGiphyChange={onGiphyChange}
                            form={form}
                            values={values}
                            requestDirectUpload={requestDirectUpload}
                            formOldValues={formOldValues}
                            setFormOldValues={setFormOldValues}
                          />
                        ) : null}
                      </div>
                      <div className={css.inputField}>
                        <label htmlFor="fileInput" className={css.uplaodIcon} onClick={onImageClick}>
                          <ProfileIconCard type="image" />
                        </label>
                        {isImageModal ? (
                          <ImageUploadModal
                            isImageModal={isImageModal}
                            onImageClick={onImageClick}
                            form={form}
                            values={values}
                            requestDirectUpload={requestDirectUpload}
                            formOldValues={formOldValues}
                            setFormOldValues={setFormOldValues}
                          />
                        ) : null}
                      </div>
                      <div className={css.inputField}>
                        <label htmlFor="fileInput" className={css.uplaodIcon} onClick={onVideoClick}>
                          <ProfileIconCard type="video" />
                        </label>
                        <VideoUploadModal
                          isVideoUpload={isVideoUpload}
                          onVideoClick={onVideoClick}
                          form={form}
                          values={values}
                          requestDirectUpload={requestDirectUpload}
                          formOldValues={formOldValues}
                          setFormOldValues={setFormOldValues}
                        />
                      </div>
                      <OutsideClickHandler onOutsideClick={() => isEmojiOpen && onEmojiClick(false)}>
                      <div className={css.emojiSection}>
                        <div className={css.uplaodIcon} onClick={() => onEmojiClick(true)}>
                          <ProfileIconCard type="emoji" />
                        </div>

                        <div className={css.emojiPick}>
                          {isEmojiOpen ? <EmojiPicker onEmojiClick={handleEmoji} /> : null}
                        </div>
                      </div>
                      </OutsideClickHandler>
                      {/* <div>
                        <ProfileIconCard type="marketplace" />
                      </div> */}
                    </div>
                  </div>
                  <Button type="submit" inProgress={requestCreateComment} disabled={limitExceed}>
                    Post
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    />
  )
};

export default EditCommentForm;
